import {PortfolioType} from "../../../../portfolio/models/Portfolio";
import {OrderNumber, OrderNumbers} from "../../../models/OrderRecord";

export type PlacedOrders = ReadonlyArray<PlacedOrder>;

export interface PlacedOrder {
    readonly type: PortfolioType;
}

export type PlacedBrokerOrders = ReadonlyArray<PlacedBrokerOrder>;

export interface PlacedBrokerOrder extends PlacedOrder {
    readonly type: PortfolioType.BROKER;
    readonly orderNumber: OrderNumber;
}

export function isBrokerOrder(order: PlacedOrder): order is PlacedBrokerOrder {
    return order.type === PortfolioType.BROKER;
}

export function placedBrokerOrders(orderNumbers: OrderNumbers): PlacedBrokerOrders {
    return orderNumbers.map(placedBrokerOrder);
}

export function placedBrokerOrder(orderNumber: OrderNumber): PlacedBrokerOrder {
    return {
        type: PortfolioType.BROKER,
        orderNumber
    };
}

export type PlacedSimulatedOrders = ReadonlyArray<PlacedSimulatedOrder>;

export interface PlacedSimulatedOrder extends PlacedOrder {
    readonly type: PortfolioType.SIMULATED;
    readonly id: number;
}

export function isSimulatedOrder(order: PlacedOrder): order is PlacedSimulatedOrder {
    return order.type === PortfolioType.SIMULATED;
}

export function placedSimulatedOrders(ids: ReadonlyArray<number>): PlacedSimulatedOrders {
    return ids.map(placedSimulatedOrder);
}

export function placedSimulatedOrder(id: number): PlacedSimulatedOrder {
    return {
        type: PortfolioType.SIMULATED,
        id
    };
}

export function isSameOrder(a: PlacedOrder, b: PlacedOrder): boolean {
    if (isBrokerOrder(a) && isBrokerOrder(b)) {
        return a.orderNumber === b.orderNumber;
    } else if (isSimulatedOrder(a) && isSimulatedOrder(b)) {
        return a.id === b.id;
    } else {
        return false;
    }
}
